module.exports = __webpack_public_path__ + "img/abaque-example.a04d57e7.jpg";